export default {
  title: 'AUTO DISPATCH SETTINGS',
  items: {
    DisableAutoDispatch: {
      label: 'Disable Auto Dispatch',
      type: 'boolean',
    },
    AutoDispatchTime: {
      label: 'Auto Dispatch Time',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchRetryAttempt: {
      label: 'Retry Attempts',
      type: 'integer',
      unit: 'retries'
    },
    DriverConfirmationPhoneNumber: {
      label: 'Driver Notification Phone Number',
      type: 'string',
      unit: ''
    },
    // RunAutopackageEnabled: {
    //   label: 'Enable Auto-package Runs',
    //   type: 'boolean',
    // },
    // RunAutodispatchEnabled: {
    //   label: 'Enable Auto-dispatching Runs',
    //   type: 'boolean',
    // },
    // RunAutodispatchNormalMode: {
    //   label: 'Run Auto Dispatch Normal Mode',
    //   type: 'dropdown',
    //   values: [
    //     'send',
    //     'assign'
    //   ]
    // },
    // RunAutodispatchExtendedMode: {
    //   label: 'Run Auto Dispatch Extended Mode',
    //   type: 'dropdown',
    //   values: [
    //     'send',
    //     'assign'
    //   ]
    // },
    // RunAutodispatchExtendedMins: {
    //   label: 'Run Auto Dispatch Extended Minutes',
    //   type: 'integer',
    //   unit: 'mins'
    // },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/auto-dispatch.js